import React from 'react';

const FooterPanel = ({ project, totalProjects, currentIndex, onNext, onPrev, onDotClick, onDetailsClick }) => {
    // Apply theme gradient as a CSS variable if it exists
    const containerStyle = project?.theme?.gradient ? {
        '--project-gradient': project.theme.gradient
    } : {};

    return (
        <footer className="footer-panel" style={containerStyle}>
            <div className="footer-left">
                <button className="description-btn" onClick={onDetailsClick}>
                    Details
                </button>
            </div>

            <div className="footer-center">
                <button onClick={onPrev} className="nav-arrow left-arrow">&lt;</button>
                <div className="dots-container">
                    {Array.from({ length: totalProjects }).map((_, idx) => (
                        <span
                            key={idx}
                            className={`nav-dot ${idx === currentIndex ? 'active' : ''}`}
                            onClick={() => onDotClick(idx)}
                        />
                    ))}
                </div>
                <button onClick={onNext} className="nav-arrow right-arrow">&gt;</button>
            </div>

            <div className="footer-right">
                <a href={project.github} className="gradient-link" target="_blank" rel="noopener noreferrer">GitHub Link</a>
                <span className="separator">, </span>
                <a href={project.releaseLink || project.url} className="gradient-link" target="_blank" rel="noopener noreferrer">
                    {project.releaseLabel || "Full Webpage"}
                </a>
            </div>
        </footer>
    );
};

export default FooterPanel;
